import { ComArribarProps } from './ComArribar.types';
// @ts-ignore
import BotoComponent from 'components/corporatiu/Boto';
const Boto: any = BotoComponent;
// @ts-ignore
import Text from 'components/corporatiu/Text';
// @ts-ignore
import Titol from 'components/corporatiu/Titol/Titol';
// @ts-ignore
import Icona from 'components/corporatiu/ui/Icona';
import styles from './comarribar.module.scss';

export default function ComArribar(props: Readonly<ComArribarProps>) {
    const { titol } = props;

    return (
        <>
            <Titol titol={titol} tag='h2' tipus='gran' />

            <div className={styles.comarribar}>
                <div>
                    <iframe
                        src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2994.465804172441!2d2.1494655765652433!3d41.36396349744707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a4a26c35ec4be9%3A0x9e9035c097bdfdf4!2sPalau%20Sant%20Jordi!5e0!3m2!1sca!2ses!4v1774022083262!5m2!1sca!2ses'
                        width='100%'
                        height='450'
                        style={{ border: 0 }}
                        allowFullScreen
                        loading='lazy'
                        className={styles.embedMapa}
                        referrerPolicy='no-referrer-when-downgrade'
                    />
                </div>
                <div>
                    <Text
                        text={"Ens trobaràs a l'Anella Olímpica i al Palau Sant Jordi"}
                        tag='p'
                        className={styles.titolEntradeta}
                    />

                    <p>PASSEIG OLÍMPIC, 5-7, 08038 BARCELONA</p>
                    <p>
                        El Palau Sant Jordi es troba a la muntanya de Montjuïc, dins de l&apos;Anella Olímpica de Barcelona.
                    </p>
                    <p>És accessible des del centre de la ciutat en transport públic, en taxi o a peu des de diverses parades de metro i bus. També disposa de pàrquing per a cotxes.
                    </p>
                    <div className={styles.botons}>
                        <Boto
                            link='https://palausantjordi.barcelona/ca/com-arribar-palausantjordi-barcelona'
                            estil='ple3cat100'
                            text='Veure la web oficial'
                            icona={'ic_linkexterior'}
                            isIconaBlanc={true}
                            isIconaDreta={true}
                            novaFinestra={true}
                            iconaInline={true}
                            className={styles.ambIcona}
                        />
                        <Boto
                            link='https://palausantjordi.barcelona/ca/accessibilitat'
                            estil='ple3cat100'
                            text="Indicacions d'accessibilitat"
                            icona={'ic_linkexterior'}
                            isIconaBlanc={true}
                            isIconaDreta={true}
                            novaFinestra={true}
                            iconaInline={true}
                            className={styles.ambIcona}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.autocar}>
                <div className={styles.autocarTitol}>
                    <Icona
                        className={styles.icona}
                        icona='info_contorn'
                        alt='informació'
                        isBlanc={false}
                        path='corporatiu'
                        mida='24'
                    />
                    <span>Oferta Sagalés</span>
                </div>
                <p>
                    Sagalés, empresa d&apos;autocars, ofereix la possibilitat de llogar la seva flota des de diverses poblacions
                    del país per facilitar l&apos;assistència al Palau Sant Jordi, segons disponibilitat. Pots demanar més
                    informació a través de: <a href='mailto:comercial@sagales.com'>comercial@sagales.com</a>.
                </p>
            </div>
        </>
    );
}
